var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.75h22.5c.69 0 1.25.56 1.25 1.25v20c0 .69-.56 1.25-1.25 1.25h-22.5c-.69 0-1.25-.56-1.25-1.25V23c0-.69.56-1.25 1.25-1.25zM28 34.25c-.69 0-1.25.56-1.25 1.25V38a1.25 1.25 0 1 0 2.5 0v-2.5c0-.69-.56-1.25-1.25-1.25zm5-7.5c-.69 0-1.25.56-1.25 1.25v10a1.25 1.25 0 1 0 2.5 0V28c0-.69-.56-1.25-1.25-1.25zm5 3.75c-.69 0-1.25.56-1.25 1.25V38a1.25 1.25 0 1 0 2.5 0v-6.25c0-.69-.56-1.25-1.25-1.25z",
    fill: "#FF5958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/barChartIcon.e043eee4cf07f32c97ad5a4c79319777.svg";
export { ForwardRef as ReactComponent };